module.exports = __webpack_public_path__ + "static/media/gt-america-standard-light-italic.e1ff3c05.woff";